export class ActionPointsAdvancedSaleChoiceResultsModel{

    public canceled: boolean;

    public isIndividuals: boolean;


    constructor(canceled: boolean, isIndividuals?: boolean) {
        this.canceled = canceled;
        this.isIndividuals = isIndividuals;
    }
}
